export default {
    namespaced: true,
    state: {
        categories: null,
        category: null,
        loading: {
            categories: true
        }
    },
    getters: {
        categories: state => state.categories,
        category: state => state.category,
        loading: state => state.loading
    },
    mutations: {
        SET_CATEGORIES(state, categories) {
            state.categories = categories
        },
        START_LOADING_CATEGORIES(state) {
            state.loading.categories = true
        },
        FINISH_LOADING_CATEGORIES(state) {
            state.loading.categories = false
        },
        SET_CATEGORY(state, category) {
            state.category = category
        },
        CLEAR_CATEGORY(state) {
            state.category = null
        },
    },
    actions: {
        async getCategories({ commit }) {
            commit('START_LOADING_CATEGORIES')

            const url = '/public/catalog'

            try {
                const resp = await this.$axios.get(url)

                commit('SET_CATEGORIES', resp.data.categories)
            } finally {
                commit('FINISH_LOADING_CATEGORIES')
            }
        },
        async getCategory({ commit }, idCategory) {
            const url = `/public/catalog/category/${idCategory}`

            const resp = await this.$axios.get(url)

            commit('SET_CATEGORY', resp.data.category)
        },
        clearCategory({ commit }) {
            commit('CLEAR_CATEGORY')
        }
    }
}
